<template>
  <div>
    <Head title="Sales Orders Delivery Runs" />
    <h1 class="mb-8 text-3xl font-bold">Sales Order/Invoicing Queue/Delivery Runs</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-dropdown-filter v-model="form.search" class="mr-0 w-full max-w-md mr-3">
        <label class="block text-gray-700">Channel:</label>
        <select v-model="form.channel" class="form-select mt-1 w-full">
          <option :value="null">-All Channels-</option>
          <option v-for="item in channels" :key="item.id" :value="item.name">{{ item.name }}</option>
        </select>
      </search-with-dropdown-filter>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset" />
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Open
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Invoiced
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div v-if="form.dateValue && url()" class="bg-white rounded-md shadow overflow-x-auto p-5 mb-5">
          <div class="flex items-center justify-between">
            <a
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              :href="`/orders/delivery-runs/invoicing-queue/invoicing-queue/download${url()}`"
              download
              target="__blank"
              title="Download"
            >
              <span>Download</span>
            </a>
          </div>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Order Date</th>
              <th class="pb-3 pt-3 px-3">Delivery Run Date</th>
              <th class="pb-3 pt-3 px-3">DR Number</th>
              <th class="pb-3 pt-3 px-3">Order Number</th>
              <th class="pb-3 pt-3 px-3">Agent</th>
              <th class="pb-3 pt-3 px-3">Customer</th>
              <th class="pb-3 pt-3 px-3">Delivery Assistant</th>
              <th class="pb-3 pt-3 px-3">Vehicle Plate Number</th>
              <th class="pb-3 pt-3 px-3 text-center">Voucher Amount</th>
              <th class="pb-3 pt-3 px-3 text-center">Transport Amount</th>
              <th class="pb-3 pt-3 px-3 text-center">Order Total</th>
              <th class="pb-3 pt-3 px-3 text-end" />
            </tr>
            <tr v-for="list in delivery_runs_packed.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.order_date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.order_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.agent }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.customer }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.user }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.plate_number ? list.plate_number : '-' }}
                </Link>
              </td>
              <td class="border-t">
                <Link v-if="list.voucherInfo && list.voucherInfo.code && list.has_discount_voucher == 0"
                  class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.voucherInfo.voucher_amount }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  0.00
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.transport }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" title="">
                  {{ list.amount }}
                </Link>
              </td>
              <td class="w-px border-t">
                <a :href="`/orders/delivery-runs/invoicing-queue/users/${list.username}/orders/${list.id}/skus`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="delivery_runs_packed.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="7">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="delivery_runs_packed.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div v-if="(delivery_runs_processed.data.length > 0 && url())" class="bg-white rounded-md shadow overflow-x-auto p-5 mb-5">
          <div class="flex items-center justify-between">
            <a
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              :href="`/download/invoiced-orders${url()}`"
              download
              target="__blank"
              title="Download"
            >
              <span>Download</span>
            </a>
          </div>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Order Date</th>
              <th class="pb-3 pt-3 px-3">Delivery Run Date</th>
              <th class="pb-3 pt-3 px-3">DR Number</th>
              <th class="pb-3 pt-3 px-3">Invoice Number</th>
              <th class="pb-3 pt-3 px-3">Order Number</th>
              <th class="pb-3 pt-3 px-3">Agent</th>
              <th class="pb-3 pt-3 px-3">Customer</th>
              <th class="pb-3 pt-3 px-3">Delivery Assistant</th>
              <th class="pb-3 pt-3 px-3">Vehicle Plate Number</th>
              <th class="pb-3 pt-3 px-3 text-center">Voucher Amount</th>
              <th class="pb-3 pt-3 px-3 text-center">Transport Amount</th>
              <th class="pb-3 pt-3 px-3 text-center">Order Total</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3 text-end" />
            </tr>
            <tr v-for="listd in delivery_runs_processed.data" :key="listd.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.order_date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.invoice_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.order_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.agent }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.customer }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.user }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.plate_number ? listd.plate_number : '-' }}
                </Link>
              </td>
              <td class="border-t">
                <Link v-if="listd.voucherInfo && listd.voucherInfo.code && listd.has_discount_voucher == 0" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.voucherInfo.voucher_amount }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  0.00
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.transport }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.amount }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" title="">
                  {{ listd.status }}
                </Link>
              </td>
              <td class="w-px border-t">
                <a :href="`/orders/delivery-runs/invoicing-queue/users/${listd.username}/orders/${listd.id}/skus`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="delivery_runs_processed.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="delivery_runs_processed.links" />
      </div>
    </div>
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDropdownFilter from '@/Shared/SearchWithDropdownFilter'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'
      
export default {
  components: {
    Head,
    Link,
    SearchWithDropdownFilter,
    Pagination,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    delivery_runs_processed: Object,
    delivery_runs_packed: Object,
    channels: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        channel: this.filters.channel,
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders/delivery-runs/invoicing-queue', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    url() {
      let query = ''
      if (this.form.search) {
        query += `search=${this.form.search}`
      }
      if (this.form.dateValue) {
        if (query) {
          query += '&'
        }
        query += `dateValue=${this.form.dateValue}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
      